import React, { useState } from 'react';
import './SubjectModules.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faFileAlt, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const getAllSubtopics = (subtopicsData) => Object.values(subtopicsData).flat();

const CalculusModules = () => {
  const modules = [
    'Module 1', 'Module 2', 'Module 3', 'Module 4', 'Module 5'
  ];

  const subtopicsData = {
    'Module 1': [
      { name: 'Limit and continuity for two variables', path: '/cal-m2-s1' },
      { name: 'Partial derivative', path: '/cal-m2-s2' },
      { name: 'Jacobian', path: '/cal-m2-s3' },
      { name: 'Taylor\'s series', path: '/cal-m3-s1' },
      { name: 'Min and Max in two variables', path: '/cal-m3-s2' },
      { name: 'Lagrange\'s method of undetermined', path: '/cal-m3-s3' }
    ],

    'Module 2': [
      { name: 'Evaluation of double integral', path: '/cal-m4-s1' },
      { name: 'Change of order', path: '/cal-m4-s2' },
      { name: 'Change of variable', path: '/cal-m4-s3' },
      { name: 'Evaluation of triple integration', path: '/cal-m4-s4' },
      { name: 'Using cylinder', path: '/cal-m4-s5' },
      { name: 'Using spherical', path: '/cal-m4-s6' }
    ],
    'Module 3': [
      { name: 'Directional derivative', path: '/cal-m6-s1' },
      { name: 'Angle between two surfaces', path: '/cal-m6-s2' },
      { name: 'Divergence and curl', path: '/cal-m6-s3' },
      { name: 'Vector differentiation', path: '/cal-m6-s4' },
      { name: 'Line integral', path: '/cal-m7-s1' },
      { name: 'Green\'s theorem', path: '/cal-m7-s2' },
      { name: 'Surface integral', path: '/cal-m7-s3' },
      { name: 'Stokes\' theorem', path: '/cal-m7-s4' },
      { name: 'Gauss divergence theorem', path: '/cal-m7-s5' }

    ],
    'Module 4': [
      { name: 'Order and Degree', path: '/de-m1-s1' },
      { name: 'Method of undetermined coefficients', path: '/de-m1-s2' },
      { name: 'Method of variation of parameters', path: '/de-m1-s3' },
      { name: 'Homogenous equation of Cauchy Euler’s type', path: '/de-m1-s4' },
      { name: 'Solving DE in Mechanical & Electrical Circuits', path: '/de-m1-s5' },


    ],
    'Module 5': [
      { name: 'Formation of pde ', path: '/de-m2-s1' },
      { name: 'Solving linear pde', path: '/de-m2-s2' },
      { name: 'Solving non-linear pde', path: '/de-m2-s3' },
      { name: 'Method of separation of variables', path: '/de-m2-s4' },

    ]

  };

  const [openModule, setOpenModule] = useState(null);

  const toggleSubtopics = (module) => {
    setOpenModule(openModule === module ? null : module);
  };

  return (
    <div className="subjectbody">
      <Link to="/courses" className="return-to-course-btn">
        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: '8px' }} />
        Back to Courses
      </Link>
      <div className="subject-header">
        <h1>Multivariable Calculus and Differential Equation</h1>
      </div>
      <div className="module-list">
        {modules.map((module) => (
          <div className="module" key={module}>
            <div className="module-header" onClick={() => toggleSubtopics(module)}>
              <span>{module}</span>
              <FontAwesomeIcon icon={openModule === module ? faChevronUp : faChevronDown} />
            </div>
            {openModule === module && (
              <ul className="subtopics">
                {subtopicsData[module] && subtopicsData[module].length > 0 ? (
                  subtopicsData[module].map((topic, index) => (
                    <li key={index}>
                      <span>{topic.name}</span>
                      <Link to={topic.path} className="article-link" state={{ subtopics: getAllSubtopics(subtopicsData), subjectPath: '/subject-CalculusModules' }}>
                        <FontAwesomeIcon icon={faFileAlt} />
                      </Link>
                    </li>
                  ))
                ) : (
                  <li>Coming Soon...</li>
                )}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CalculusModules;
